import { INTERNAL_ROUTES } from './constants';

import { isServerCheck } from '@/modules/env/isServerCheck';

export function resolveApiHost(url: string) {
  /* If we are not behind web-routing i.e. if we are running locally
     or on the client then we need to route through web-api-routing
     as normal
  */
  if (
    !isServerCheck() ||
    process.env.NEXT_RUNTIME !== 'nodejs' ||
    (process.env.DEPLOY_ENV !== 'staging' &&
      process.env.DEPLOY_ENV !== 'production')
  ) {
    return process.env.NEXT_PUBLIC_API_HOST;
  }

  const key = url.startsWith('/presentation/')
    ? 'presentation'
    : url.split('/')[3];

  const apiHost = key ? INTERNAL_ROUTES[key] : undefined;

  return apiHost ?? process.env.NEXT_PUBLIC_API_HOST;
}
